import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Contact {
  static endpoints = {
    index:         `${baseUrl}/contact`,
    customCashout: `${baseUrl}/contact/custom-cashout`,
  };

  static sendMessage(payload) {
    return axios.post(this.endpoints.index, payload).then((response)=> response.data.message);
  };

  static customCashoutRequest(payload) {
    return axios.post(this.endpoints.customCashout, payload).then((response)=> response.data.message);
  };

}

